<template>
  <div id="app">
    <VueHeader :windowWidth="windowWidth" :isMobile="isMobile"></VueHeader>
    <div>
      <router-view :windowWidth="windowWidth" :isMobile="isMobile"/>
    </div>
    <VueFooter :isMobile="isMobile"></VueFooter>
  </div>
</template>

<script>
import VueFooter from './components/VueFooter';
import VueHeader from './components/VueHeader';

let resizeHandler;

export default {
  components: { VueFooter, VueHeader },
  computed: {
    isMobile: function isMobile() {
      return this.windowWidth <= 768;
    },
  },
  data() {
    return {
      windowWidth: 1280,
    };
  },
  mounted: function ready() {
    const vm = this;

    vm.windowWidth = window.innerWidth;
    resizeHandler = (evnt) => {
      vm.windowWidth = evnt.target.innerWidth;
    };

    window.addEventListener('resize', resizeHandler);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', resizeHandler);
  },
};
</script>

<style>
html, body, #app {
  font-family: 'Avenir', 'Hevelica', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  padding: 0;
  color: rgba(0,0,0,0.7);
  /*background: #f8f8f9;*/
  /*background: #fcfcfc;*/
  background: #FAFDFD;
}

h1, h2, h3, h4, h5, h6, p, span, div {
  font-weight: 400;
}
/*
.vf-bg-landing { background: #263141; }
.vf-bg-aggregation { background: #42368D; }
.vf-bg-valuations { background: #0F3D7E; }
.vf-bg-assessments { background: #701B5F; }*/

.text-shadow-img { text-shadow: 1px 1px 30px rgba(0, 0, 0, 0.70); }
/*.text-shadow { text-shadow: 1px 1px 8px rgba(0,0,0,0.05); }*/
.text-shadow { text-shadow: 1px 1px 15px rgba(0, 0, 0, 0.4); }
.box-shadow { box-shadow: 1px 1px 8px rgba(0,0,0,0.05); }

.ivu-btn {
  height: 32px;
  padding: 0 16px;
}

/* gives blur as background for ghost buttons*/
/*.ivu-btn-ghost {
  color: #fff;
  background-color: rgba(255,255,255,.2);
  border-color: #dfe4e9;
}*/

.primary {
  color: #39f;
}

.green {
  color: #00cc66;
}

.white {
  color: #fff;
}

.hero-text {
  font-size: 28px;
}

.dark-text {
  color: rgba(0,0,0,0.70);
}

.padding-50 {
  padding: 0 50px;
}

.padding-16 {
  padding: 0 16px;
}

.width-40-percent {
  width: 40%;
}

.width-85-percent {
  width: 85%;
}

.ivu-input-wrapper, .ivu-select {
  margin-top: 8px;
  margin-bottom: 8px;
}

.feature-card {
  height: 200px;
}

.section {
  padding-top: 70px;
  padding-bottom: 70px;
}
.title-section {
  padding-bottom: 36px;
  text-align: center;
}

.section-title span {
  font-size: 26px;
}

.section-title-description {
  font-size: 16px;
  max-width: 500px;
}

.section-title-mobile {
  padding: 0 6px;
}

.section-title-mobile span {
  font-size: 20px;
}

.section-title-description-mobile {
  padding: 0 16px;
  font-size: 14px;
  max-width: 500px;
}

.ivu-card {
  box-shadow: 0 1px 18px rgba(0, 0, 0, 0.1);
}

.ivu-modal-confirm-footer {
  margin-bottom: 0px;
}

.page-title {
  margin-bottom: 16px;
}

.lift-on-hover:hover {
  transform: translateY(-3px);
  box-shadow: 2px 1px 16px rgba(0,0,0,0.05);
  cursor: pointer;
}

.border-top {
  border-top: 1px solid #d7dde4;
}
</style>



// WEBPACK FOOTER //
// src/App.vue